import axios from "axios";
import { getAxiosConfigWithToken } from "../helpers/functions_helper"
import * as url from "../helpers/url_helper"

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class CompanyCategoryService {
    async getCompanyCategory(DATA: any) {
        const response = await axios
            .get(SERVER_URL + url.GET_COMPANY_CATEGORY + "/" + DATA.id + "/" + DATA.company_category_id,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async getCompanyCategoryList(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.GET_COMPANY_CATEGORY_LIST, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async createCompanyCategory(DATA: any) {
        const response = await axios
            .put(SERVER_URL + url.CREATE_COMPANY_CATEGORY, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async updateCompanyCategory(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.UPDATE_COMPANY_CATEGORY, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async deleteCompanyCategory(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.DELETE_COMPANY_CATEGORY, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }
}

export default new CompanyCategoryService();